"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortest = void 0;
const shortest = (...list) => {
    const listLength = list.length;
    let result = list[0];
    for (let index = 1; index < listLength; index++) {
        const candidate = list[index];
        if (candidate.length < result.length) {
            result = candidate;
        }
    }
    return result;
};
exports.shortest = shortest;
